var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.productCode == 1)?_c('yx-growup-preview'):_vm._e(),(_vm.productCode == 16)?_c('czl-growup-preview'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }